

import { useDarkMode } from '@/hooks/useDarkMode';

import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogTitle } from '@/components/ui/dialog';
import { AlertTriangle } from 'lucide-react';
export default function DeleteConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm Deletion",
  message = "Are you sure you want to delete this item? This action cannot be undone.",
  confirmText = "Delete",
  cancelText = "Cancel"
}) {
  const darkMode = useDarkMode();
  
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
            <AlertTriangle className="w-6 h-6 text-red-600" />
          </div>
          <div className="flex-1">
            <DialogTitle className="text-xl font-semibold mb-2 transition-colors" style={{ color: darkMode.textPrimary }}>{title}</DialogTitle>
            <DialogDescription className="text-base transition-colors" style={{ color: darkMode.textSecondary }}>
              {message}
            </DialogDescription>
          </div>
        </div>
        
        <DialogFooter className="mt-6 gap-2 sm:gap-2">
          <Button
            variant="outline"
            onClick={onClose}
            className="flex-1"
            data-testid="delete-cancel-btn"
          >
            {cancelText}
          </Button>
          <Button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className="flex-1 bg-red-600 hover:bg-red-700 text-white"
            data-testid="delete-confirm-btn"
          >
            {confirmText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
